import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { PasslyDropdown } from '@app/components';
import { changeOrganizationSelect, resetState } from '@app/store/actions';
import { localStore } from '@app/helpers';
import {useTypedTranslation} from '@app/hooks';

interface IOrgSelect {
    withoutLabel?: boolean;
    fullWidth?: boolean;
    enabledLocally?: boolean;
}

export const OrganizationsSelect: React.SFC<IOrgSelect> = ({withoutLabel, fullWidth, enabledLocally}) => {
    const { translation } = useTypedTranslation();
    const localStorageOrganization = localStore.getItem('org_filter') ? localStore.getItem('org_filter') : '';

    const selectData = useSelector((state: any) => state.basic.shellConfig.organizations);
    const selectDataLoading: boolean = useSelector((state: any) => state.basic.shellConfigLoading);
    const organizationsEnabled: boolean = useSelector((state: any) => state.listPageBar.sortingEnabledOptions.organizationsEnabled);
    const initialOrd = selectData.find((selectedElement: any) => selectedElement.id === localStorageOrganization);
    const [selected, setSelected] = React.useState(initialOrd);
    const dispatch = useDispatch();

    useEffect(() => {
        if (!selectDataLoading && selected === '') {
            const firstOrganization = selectData[0].id;
            setSelected(firstOrganization);
            dispatch(resetState());
            dispatch(changeOrganizationSelect(firstOrganization));
            localStore.setItem('org_filter', firstOrganization);
        }

        if (localStorageOrganization !== '' && localStorageOrganization !== null) {
            setSelected(initialOrd);
            dispatch(resetState());
            dispatch(changeOrganizationSelect(localStorageOrganization));
        }
    }, []);

    const handleChange = (event: any) => {
        if (event.value.id !== selected) {
            dispatch(resetState());
            dispatch(changeOrganizationSelect(event.value.id));
            setSelected(event.value as string);
            localStore.setItem('org_filter', event.value.id as string);
        }
    };

    return (
        <>
            {!selectDataLoading && selectData.length > 1 && (organizationsEnabled || enabledLocally) && (
                <PasslyDropdown
                    id='orgSelector'
                    className={`orgSelector ${fullWidth ? 'orgSelector__fullWidth' : ''}`}
                    value={selected || undefined}
                    options={selectData}
                    onChange={handleChange}
                    appendTo={document.body}
                    optionLabel='name'
                    label={withoutLabel ? '' : translation('ORGANIZATION_SELECTION')}
                />
            )}
        </>
    );
};
